import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';

interface NoAccessProps {
  /** Feature name shown in the message */
  feature?: string;
  /** Replaces the standard message when a page is closed for its own reason. */
  message?: string;
}

export default function NoAccess({ feature, message }: NoAccessProps) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 8,
        padding: '16px',
        color: 'var(--text-secondary)',
      }}
    >
      <h2 style={{ margin: 0, fontSize: 'var(--font-size-large)', color: 'var(--text-primary)' }}>
        Access Restricted
      </h2>
      <p style={{ margin: 0, maxWidth: 560, lineHeight: 1.5 }}>
        {message ?? (feature
          ? `You do not have permission to access ${feature}. Contact your administrator to request access.`
          : 'You do not have permission to access this page. Contact your administrator to request access.')}
      </p>
      {/* The same way out as Page Not Found: one filled button to Home (the dashboard). */}
      <Button
        variant="contained"
        size="small"
        onClick={() => navigate('/dashboard')}
        sx={{ textTransform: 'none' }}
      >
        Go to Home
      </Button>
    </div>
  );
}
